import * as s from './styles/index.module.css';

import type { IFilterLayout } from './types';

const SearchFilterLayout = ({
  headline,
  filters,
  results,
  search,
  className = '',
}: IFilterLayout) => {
  return (
    <div className={`grid ${s.layout} ${className}`}>
      <h1 className="h4 semibold">{headline}</h1>
      <div className={`${s.filters} unifiedSearchFilters`}>
        {filters}
      </div>
      <div className={s.search}>
        {search}
      </div>
      <div className={s.results}>
        {results}
      </div>
    </div>
  );
};

export default SearchFilterLayout;
